<template>

    <div class="container-fluid">

        <div class="row">
            <div class="col-md-12">
                <div class="card">

                    <v-app>
                        <v-container fluid>
                            <v-card elevation="2" outlined>
                                <v-card-title>
                                    <!--                                    v-if="$can('transaction_create')"-->
                                    <v-btn  to="/category/create" rounded color="#308BB0" class="text-white" v-status='"category_create"'>

                                        <v-icon>mdi-plus</v-icon>
                                        افزودن دسته بندی
                                    </v-btn>
                                    <v-spacer/>
                                    {{$route.meta.title}}
                                    <v-spacer/>
                                    <v-btn :loading="loading" @click="fetchIndexData" color="primary" rounded
                                           class="text-white">
                                        <v-icon>mdi-refresh</v-icon>
                                        به روزرسانی
                                    </v-btn>

                                </v-card-title>
                                <v-divider/>
                                <div class="row">
                                    <div class="col-md-12 p-5">

                                        <data-table
                                            :data="data"
                                            :columns="columns"
                                            :debounce-delay="5000"
                                            :translate="translate"
                                            :per-page="[10, 25, 50, 100, 400]"
                                            @on-table-props-changed="reloadTable"
                                        >
                                        </data-table>

                                    </div>
                                </div>

                            </v-card>

                        </v-container>

                    </v-app>

                </div>
            </div>
        </div>

    </div>
</template>

<script>
import CategoryPicker from "./categoryPicker";
import Btn from "./Btn";
import {SET_BREADCRUMB} from "../../../core/services/store/breadcrumbs.module";


export default {
    components: {
        CategoryPicker,

    },
    data() {
        return {

            data: {},
          loading:false,
            url: 'category/get-all',
            translate: {
                nextButton: 'بعدی',
                previousButton: 'قبلی',
                rowsPerPageText: 'تعداد در صفحه',
                noDataText: 'داده ای برای نمایش وجود ندارد',
                placeholderSearch: 'جستجو',
            },

            tableProps: {
                search: '',
                length: 10,
                column: 'id',
                dir: 'desc',
            },
            columns: [
                {
                    label: 'شناسه',
                    name: 'id',
                    orderable: true,
                    colStyle: 'width: 100px;'
                },
                {
                    label: 'نام',
                    name: 'name',
                    orderable: true,
                },
                {
                    label: 'آدرس',
                    name: 'slug',
                    transform: (value, data) => {
                        return value.data.slug == null ? '<p class="text-danger">ندارد</p>' : value.data.slug;
                    },
                    orderable: true,
                },
                {
                    label: 'زیرمجموع',
                    name: 'parent',
                    transform: (value, data) => {
                        return !value.data.parent ? '<p class="text-danger">ندارد</p>' : value.data.parent.name;
                    },
                },

                {
                    label: 'نوع سرویس',
                    name: 'service',
                  transform: (val) => {
                      return this.$options.filters.serviceType(val.data.service.nameLand)
                  }
                },
                {
                    label: 'وضعیت نمایش',
                    name: 'status',
                    orderable: true,
                    transform: (value, data) => {
                        return value.data.status ? 'فعال' : 'غیر فعال';
                    },

                },
                {
                    label: ' سربرگ',
                    name: 'special',
                    orderable: true,
                    transform: (value, data) => {
                        return value.data.special ? 'بله' : 'خیر';
                    },
                },
              {
                label: 'تاریخ ویرایش',
                name: 'updated_at',
                orderable: true,
                transform: (val) => {
                  console.log(val.data)
                  return this.$options.filters.longDate(val.data.updated_at)
                }
              },
                {
                    label: 'عملیات',
                    name: 'actions',
                    component: Btn,
                    handler: this.action,
                    event:'action',
                    meta: {
                        permission_prefix: 'category_',
                    }

                },
            ],

        }
    },

    created() {
        this.permissionStatus('permission_create');
        this.getData(this.url)
        this.$store.dispatch(SET_BREADCRUMB, [{ title: this.$route.meta.title }]);

    },
    methods: {
        getData(url = this.url, options = this.tableProps) {
            this.requestApiGet(this.url, options).then(response => {
                this.data = response.data
            })
        },

        reloadTable(tableProps) {
            this.getData(this.url, tableProps)
        },

        action(data, type) {
            this[type](data)

        },
        delete(data) {
          this.$can()
            this.$swal({
                text: 'آیا از حذف این دسته بندی اطمینان دارید؟',
                icon: 'question',
                showCancelButton: true,
                confirmButtonText: 'بله',
                cancelButtonText: 'خیر',
                reverseButtons: true,
                confirmButtonClass: 'btn btn-danger',
                cancelButtonClass: 'btn btn-secondary',
                buttonsStyling: false
            }).then(result => {
                if (result.isConfirmed) {
                    this.requestApiDelete(`categories/${data.id}`).then(response => {
                        this.reloadTable(this.tableProps)
                        this.$toast.success('دسته بندی با موفقیت حذف شد')
                    })
                }

            })
        },

        edit(data){
            this.$router.push({name:'category.edit',params:{id:data.id}})
        }
    }
}
</script>
<style>

</style>
